const CATEGORIES = [
  { key: 'proteinOptions', label: 'Protein' },
  { key: 'starchOptions', label: 'Starch' },
  { key: 'veggieOptions', label: 'Vegetables' },
  { key: 'sauceOptions', label: 'Sauce' },
  { key: 'garnishOptions', label: 'Garnish' },
];

const stripSF = (s) => (s || '').replace(/^SF /, '').trim();

/** Mirrors utils/cartPricing.js: a la carte price, falling back to the
 *  subscription price for a variant that has no a la carte price yet. */
const optionSurcharge = (option) =>
  Number(option.priceALaCarte) || Number(option.priceSubscription) || 0;

/** Selected ingredients per category, dropping the "No Sauce"/"No Starch"
 *  sentinels and empty categories. `names` is the plain list; `items` adds each
 *  name's `surcharge` so callers can attribute a premium price to its option. */
export function summarizeSelectedIngredients(meal) {
  return CATEGORIES
    .map(({ key, label }) => {
      const options = meal?.[key];
      if (!options || !Array.isArray(options)) return null;
      const items = options
        .filter((o) => o.isActive && o.name !== 'No Sauce' && o.name !== 'No Starch')
        .map((o) => ({ name: stripSF(o.name), surcharge: optionSurcharge(o) }))
        .filter((o) => o.name);
      if (items.length === 0) return null;
      return { label, items, names: items.map((o) => o.name) };
    })
    .filter(Boolean);
}
